export default {
  routers: [
    // 首页
    {
      path: "/index",
      name: "indexC",
      component: () => import("@/views/toc/indexView.vue"),
    },
    // 筛选列表
    {
      path: "/search",
      name: "tocSearch",
      component: () => import("@/views/toc/searchView.vue"),
    },
    // 课程-列表
    {
      path: "/course",
      name: "tocCourse",
      component: () => import("@/views/toc/courseView.vue"),
    },
    // 课程详情
    // {
    //   path: "/detail",
    //   name: "tocDetail",
    //   component: () => import("@/views/toc/mallView.vue"),
    // },
    // 课程播放
    {
      path: "/play",
      name: "tocPlay",
      component: () => import("@/views/toc/playView.vue"),
    },
    // 直播-列表
    {
      path: "/live",
      name: "tocLive",
      component: () => import("@/views/toc/liveView.vue"),
    },
    // 直播-详情
    {
      path: "/live/detail",
      name: "tocLiveDetail",
      component: () => import("@/views/toc/liveDetail.vue"),
    },
    // 班级-列表
    {
      path: "/class",
      name: "tocClass",
      component: () => import("@/views/toc/classView.vue"),
    },
    // 班级-详情
    {
      path: "/class/detail",
      name: "tocClassDetail",
      component: () => import("@/views/toc/classDetail.vue"),
    },

    // 购买流程-确定订单
    {
      path: "/order/confirm/:type/:id",
      name: "tocOrderConfirm",
      component: () => import("@/views/toc/orderConfirm.vue"),
    },
    // 购买流程-订单支付
    {
      path: "/order/pay/:type/:id/:orderId",
      name: "tocOrderPay",
      component: () => import("@/views/toc/orderPay.vue"),
    },
    // 购买流程-购买成功
    {
      path: "/order/success/:type/:id/:orderId",
      name: "tocOrderSuccess",
      component: () => import("@/views/toc/orderSuccess.vue"),
    },


    // c端页面辅助功能页（法律声明、隐私政策、联系我们）
    {
      path: "/about/:type",
      name: "tocAbout",
      component: () => import("@/views/toc/about.vue"),
    },


  ],
};
